import React, { useCallback, useState, useEffect } from "react";
import Filter from "../../components/Filter/Filter";
import "../pages.scss";
import AddBoxIcon from '@mui/icons-material/AddBox';
import Button from '@mui/material/Button';
import { usePermissionContext } from "../../contexts/permission-context";
import { fetchAPIData, getCompanyId, getToken, getUser, cleanObject, generateHiddenColumns, hideSecret, HIDDEN_SECRET, PermissionsCheck, hasPermission, companyManage, companyPermissionOptions, createFilterOptions, createSortFieldOptions } from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import PreviewIcon from '@mui/icons-material/Preview';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import Tooltip from "@mui/material/Tooltip";
import Divider from '@mui/material/Divider';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import InfoDialog from "../../components/Dialogs/InfoDialog";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import axios from 'axios';
import CompanyDialog from "./CompanyDialog";
import Ajv from "ajv";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import CompanyEnvisionDialog from "./CompanyEnvisionDialog";
const companySchemaRequired = require("../../json/companySchema.json").create.required;
const companySchemaOptional = require("../../json/companySchema.json").create.optional;
const companySchemaUpdateRequired = require("../../json/companySchema.json").update.required;
const companySchemaUpdateOptional = require("../../json/companySchema.json").update.optional;
const ajv = new Ajv({ strict: false });

const uiSchema = {
  "solution": {
    "ui:options": {
      emptyValue: ''
    }
  },
  "sizeLimits": {
    "ui:options": {
      emptyValue: ''
    }
  },
  "workflowFeatures": {
    "nuxeoaudit": {
      "ui:placeholder": "Enter feature list as a comma delimited string. The feature state should be specified as True or False. i.e. <featureName>=<True/False>"
    },
    "nuxeoauditworkflow": {
      "ui:placeholder": "Enter feature list as a comma delimited string. The feature state should be specified as True or False. i.e. <featureName>=<True/False>"
    },
    "idp": {
      "ui:placeholder": "Enter feature list as a comma delimited string. The feature state should be specified as True or False. i.e. <featureName>=<True/False>"
    }
  },
  "cspToMDMDocumentTypes": {
    "ui:placeholder": "Enter CSP to MDM mappings as a comma delimited string. i.e. <CSP DocType>=<MDM DocType>, ..."
  },
  "mediaExtensions": {
    "ui:options": {
      orderable: false
    }
  },
  "skpCustomerIds": {
    "ui:options": {
      orderable: false
    }
  },
  "cspTenantAdmins": {
    "ui:options": {
      orderable: false
    }
  },
  "supportEmailIds": {
    "ui:options": {
      orderable: false
    }
  },
  "enVisionServerUser": {
    "ui:autocomplete": "off"
  },
  "enVisionServerUserSecret": {
    "ui:widget": "password",
    "ui:autocomplete": "new-password"
  },
  "cspTenantSecret": {
    "ui:widget": "password",
    "ui:autocomplete": "new-password"
  },
  "enVisionServerPrimaryUser": {
    "ui:autocomplete": "off"
  },
  "enVisionServerPrimaryUserSecret": {
    "ui:widget": "password",
    "ui:autocomplete": "new-password"
  }
};


const Companies = () => {
  const { permissions } = usePermissionContext();
  const [apiData, setApiData] = useState({});
  const [data, setEnVisionData] = useState({});
  const [rowJsonData, setRowJsonData] = useState({});
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('view');  // default to view mode
  const [action, setAction] = useState('');
  const [openInfoDialog, setOpenInfoDialog] = useState(false);


  const [isReindexing, setIsReindexing] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [reload, setReload] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmProps, setConfirmProps] = useState({});

  const [originalClientSecret, setOriginalClientSecret] = useState(""); // store original client secret
  const [originalCspTenantSecret, setOriginalCspTenantSecret] = useState(""); // store original csp secret
  const [originalEnVisionServerPrimaryUserSecret, setOriginalEnVisionServerPrimaryUserSecret] = useState(""); // store original enVision Server Primary User Secret


  const reindexDialogTitle = "Reindexing in Progress";
  const reindexTextContent = "Reindexing in progress. Please do not click the reindexing icon again.";

  const DEFAULT_COMPANY_ID = getCompanyId();

  const formId = 'CreateCompanyDialog';
  const [isLoading, setIsloading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const handleClickOpen = () => {

    let rowData = {};
    const JsonData = rowData;

    setRowJsonData(JsonData);

    setMode('create');

    setOpen(true);
    setReadOnly(false);
  };

  const handleClose = () => {

    setOpen(false);
  };

  const [company, setCompany] = usePersistentStorage("company", []);

  const hasCompanyManage = hasPermission(permissions, companyManage);
  // console.log("hasCompanyManage : " + hasCompanyManage);

  useEffect(() => {
    // check if localstorge had data for the current tab
    setApiData(company);
  }, []);

  const handleInfoDialogClose = () => {
    setOpenInfoDialog(false);
  };

  const getColumns = () => {
    return (hasCompanyManage && columns) || columns.filter(obj => { return obj.field !== "actions" });
  };

  const toggleColumnPinning = () => {
    return (hasCompanyManage && 'columnPinning') || '';
  };

  const initialSnackbarState = {
    open: false,
    message: '',
    alertTitle: '',
    severity: 'info',
    hideDuration: 1000
  };

  const [notify, setNotify] = useState(
    initialSnackbarState
  );

  const handleDialogClose = () => {
    setShowDialog(false);
  };


  const fieldData = [
    'portalCompanyId', 'name', 'edition', 'solution', 'mediaExtensions',
    'skpCustomerIds', 'mlEnabled', 'embeddedText', 'sharedCSPTenant', 'enVisionUpdateIDP', 'supportEmailIds',
    'userInactiveDays', 'processReportSnapshotDays', 'documentExpirationDays', 'retentionType',
    'idpOutputEnabled', 'idpOutputLocation', 'createdDate', 'modifiedDate'
  ];

  const sortFieldData = [
    // {
    //   field: 'companyId',
    //   label: 'Company ID'
    // },
    {
      field: 'portalCompanyId',
      label: 'Portal Company ID'
    },
    {
      field: 'name',
      label: 'Name'
    },
    {
      field: 'edition',
      label: 'Edition'
    },
    {
      field: 'createdDate',
      label: 'Created Date'
    },
    {
      field: 'modifiedDate',
      label: 'Modified Date'
    }
  ];

  const totalLabel = "Matching Companies";

  const getActionButtons = (params) => {
    let actionButtons = [];

    let editButton = <GridActionsCellItem icon={
      <Tooltip title="Edit" arrow placement="right">
        <EditIcon />
      </Tooltip>}
      label='View'
      onClick={viewEditData(params.row)}
      disabled={params.row.companyId === DEFAULT_COMPANY_ID}
    />;

    hasCompanyManage && actionButtons.push(editButton);

    if (params.row.companyId > 0 && params.row.cspTenantUrl) {

      let reindexButton = <GridActionsCellItem icon={
        <Tooltip title="Reindex" arrow placement="right">
          <CheckIcon />
        </Tooltip>}
        label='Reindex'
        onClick={reindexCompanyData(params.row)}
        disabled={isReindexing}
      />;

      hasCompanyManage && actionButtons.push(reindexButton);
    }

    if (params.row.enVisionServerUrl && params.row.enVisionCompanyCreated) {

      let enVisionButton = <GridActionsCellItem icon={
        <Tooltip title="View enVision Company" arrow placement="right">
          <VerifiedUserIcon style={{ color: params.row.enVisionCompanyCreated == true ? '#82c027' : "" }} />
        </Tooltip>}
        label='View enVision'
        onClick={setEnVisionCompany(params.row)}
      />;

      hasCompanyManage && actionButtons.push(enVisionButton);
    }

    if (params.row.enVisionServerUrl && params.row.enVisionCompanyCreated) {

      let enVisionButton = <GridActionsCellItem icon={
        <Tooltip title="Edit enVision Company" arrow placement="right">
          <NoteAltIcon />
        </Tooltip>}
        label='Edit enVision'
        onClick={editEnVisionCompany(params.row)}
      />;

      hasCompanyManage && actionButtons.push(enVisionButton);
    }

    if (params.row.enVisionServerUrl && !params.row.enVisionCompanyCreated && params.row.enVisionServerPrimaryUser && params.row.enVisionServerPrimaryUserSecret) {

      let enVisionCreateButton = <GridActionsCellItem icon={
        <Tooltip title="Make enVision Company" arrow placement="right">
          <AddModeratorIcon />
        </Tooltip>}
        label='Create enVision'
        onClick={createEnVisionCompany(params.row)}
        //onClick={viewEditData(params.row)}
        disabled={isReindexing}
      />;

      hasCompanyManage && actionButtons.push(enVisionCreateButton);
    }




    return actionButtons;

  };

  const columns = [
    // {
    //   field: 'id',
    //   type: 'number',
    //   headerName: 'ID',
    //   hide: true,
    //   minWidth: 50,
    //   flex: 1,
    //   headerAlign: 'left',
    //   align: 'left',
    // },
    {
      field: 'actions',
      hideable: false,
      type: 'actions',
      headerName: 'Actions',
      minWidth: 84,
      maxWidth: 84,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      getActions: (params) => getActionButtons(params),
    },
    {
      field: 'companyId',
      hideable: false,
      headerName: 'Company ID',
      type: 'number',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      valueFormatter: (params) => {
        return params.value.toString();
      }
    },
    {
      field: 'portalCompanyId',
      headerName: 'Portal ID',
      type: 'number',
      hide: true,
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      valueFormatter: (params) => {
        return params.value.toString();
      }
    },
    {
      field: 'name',
      hideable: false,
      headerName: 'Company Name',
      minWidth: 225,
      maxWidth: 225,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      field: 'edition',
      headerName: 'Edition',
      hide: true,
      renderCell: renderCellExpand,
      minWidth: 150,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'solution',
      headerName: 'Solution',
      hide: true,
      renderCell: renderCellExpand,
      minWidth: 150,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'userInactiveDays',
      headerName: 'User Inactive Days',
      type: 'number',
      hide: true,
      minWidth: 150,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: "documentExpirationDays",
      headerName: "Doc Expiration Days",
      type: 'number',
      hide: true,
      minWidth: 150,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: "processReportSnapshotDays",
      headerName: "Report Snapshot Days",
      type: "number",
      hide: true,
      minWidth: 160,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'mlEnabled',
      headerName: 'ML Enabled',
      hideable: false,
      type: 'boolean',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value ? 'Y' : 'N'}
          </>
        );
      }
    },
    {
      field: "schemaNameIncluded",
      headerName: "Schema Name Included in ML request",
      type: "boolean",
      hide: true,
      minWidth: 260,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value ? 'Y' : 'N'}
          </>
        );
      }
    },
    {
      field: "embeddedText",
      headerName: "Embedded Text",
      type: "boolean",
      hide: true,
      minWidth: 140,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value ? 'Y' : 'N'}
          </>
        );
      }
    },
    {
      field: "sharedCSPTenant",
      headerName: "Shared Tenant",
      type: "boolean",
      hide: true,
      minWidth: 140,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value ? 'Y' : 'N'}
          </>
        );
      }
    },
    {
      field: "enVisionUpdateIDP",
      headerName: "Envision Update IDP",
      type: "boolean",
      hide: true,
      minWidth: 140,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value ? 'Y' : 'N'}
          </>
        );
      }
    },
    {
      field: "idpOutput",
      headerName: "IDP Output",
      hide: true,
      minWidth: 200,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        let idpOutputEnabled = params.row.idpOutputEnabled === undefined ? false : params.row.idpOutputEnabled;

        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.row.idpOutputEnabled ?
              <>
                <>&nbsp;<strong>enabled</strong>:&nbsp;{idpOutputEnabled.toString()}</>
                <><br />&nbsp;<strong>location</strong>:&nbsp;{params.row.idpOutputLocation}</>
              </>
              :
              <>
                &nbsp;<strong>enabled</strong>:&nbsp;{idpOutputEnabled.toString()}
              </>
            }
          </div>
        );
      },
    },
    {
      field: "cspToMDMDocumentTypes",
      headerName: "CSP To MDM Doc Types",
      hide: true,
      minWidth: 260,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && Object.keys(params.value).map((cspDocType) => (
              <><strong>{cspDocType}</strong>:&nbsp;{params.value[cspDocType]}<br /></>
            ))}
          </div>
        );
      },
    },
    {
      field: "retention",
      headerName: "Retention",
      hide: true,
      minWidth: 150,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.row.retentionType && (
              <>&nbsp;<strong>type</strong>:&nbsp;{params.row.retentionType}</>
            )}

            {(params.row.retentionType === 'PCS' && params.row.pcsTenantId > 0) && (
              <><br />&nbsp;<strong>tenant</strong>:&nbsp;{params.row.pcsTenantId}</>
            )}

          </div>
        );
      },
    },
    {
      field: "skpCustomerIds",
      headerName: "SKP CustomerIds",
      hide: true,
      minWidth: 160,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && params.value.map((item) => <>{item}<br /></>)}
          </div>
        );
      },
    },
    {
      field: "mediaExtensions",
      headerName: "Media Extensions",
      hide: true,
      minWidth: 200,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <div>
            {params.value && params.value.map((line, index) => (
              <>{(index + 1) % 3 === 0 ? (
                <>{line}{index !== params.value.length - 1 ? ',' : ''}<br /></>
              )
                : (
                  <>{line}{index !== params.value.length - 1 ? ',' : ''}</>
                )}
              </>
            ))}
          </div>
        );

      },
    },
    {
      field: "sizeLimits",
      headerName: "File Size Limits",
      minWidth: 150,
      flex: 1,
      hide: true,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && Object.keys(params.value).map((ext) => (
              <>{ext} : {params.value[ext]} MB<br /></>
            ))}
          </div>
        );
      },
    },
    {
      field: "eventTopics",
      hideable: false,
      headerName: "Event Topics",
      minWidth: 250,
      maxWidth: 255,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        //console.log("eventtopics row: ", params.row, params.value);

        return (

          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && Object.keys(params.value).map((event) => (
              <>
                <strong><u>{event}</u>:</strong> <br />
                <>&nbsp;&nbsp;<strong>in:</strong>{params.value[event].in}<br /></>
                <>&nbsp;&nbsp;<strong>out:</strong>{params.value[event].out}<br /></>
              </>
            ))}
          </div>
        );
      }

    },
    {
      hideable: false,
      field: "cspTenantUrl",
      headerName: "CSP Tenant",
      minWidth: 250,
      //maxWidth: 200,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        let text;

        if (params.row.cspTenantUrl && params.row.cspTenantSecret) {
          text = <><strong>url: </strong><a style={{ cursor: 'pointer' }} href={params.value} target="_blank" rel="noreferrer">{params.row.cspTenantUrl}</a>
            <br /><strong>secret: </strong>{hideSecret(params.row.cspTenantSecret)}</>
        } else {
          if (params.row.cspTenantUrl) {
            text = <>
              <strong>url: </strong>
              <a style={{ cursor: 'pointer' }} href={params.value} target="_blank" rel="noreferrer">{params.row.cspTenantUrl}</a>
            </>
          }
        }

        return (
          <>
            <div style={{ flexDirection: 'column', display: 'inline-block' }}>
              {text}
              {params.row.cspTenantAdmins &&
                (
                  <>
                    <br /><strong>admins: </strong>{params.row.cspTenantAdmins && params.row.cspTenantAdmins.length > 1 ? <br /> : null}
                    {params.row.cspTenantAdmins && params.row.cspTenantAdmins.map((item) => <>{item}<br /></>)}
                  </>
                )}
            </div>
          </>
        );
      }
    },
    {
      field: "supportEmailIds",
      hideable: false,
      headerName: "Support Emails",
      minWidth: 320,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && params.value.map((item) => <>{item}<br /></>)}
          </div>
        );
      },
    },
    {
      field: "conductorServiceUrl",
      hideable: false,
      headerName: "Conductor Service URL",
      minWidth: 200,
      //maxWidth: 200,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        let text;
        if (params.row.conductorServiceUrl) {
          text = <>
            <strong>url: </strong>
            <a style={{ cursor: 'pointer' }} href={params.value} target="_blank" rel="noreferrer">{params.row.conductorServiceUrl}</a>
          </>
        }

        return (
          <>
            <div style={{ flexDirection: 'column', display: 'inline-block' }}>
              {text}
            </div>
          </>
        );
      },
    },
    {
      field: "envisionServerUrl",
      hideable: false,
      headerName: "enVision Server URL",
      minWidth: 325,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <>
            <div style={{ flexDirection: 'column', display: 'inline-block' }}>
              {params.row.enVisionServerUrl &&
                <>
                  <strong>url: </strong><a style={{ cursor: 'pointer' }} href={params.row.enVisionServerUrl} target="_blank" rel="noreferrer">{params.row.enVisionServerUrl}</a>
                  <br />
                </>
              }
              {params.row.enVisionServerUser &&
                <>
                  <strong>enVision Server User: </strong>{params.row.enVisionServerUser}
                  <br />
                </>
              }
              {params.row.enVisionServerUserSecret &&
                <>
                  <strong>enVision Server User Secret: </strong>{hideSecret(params.row.enVisionServerUserSecret)}
                  <br />
                </>
              }
              {params.row.enVisionServerPrimaryUser &&
                <>
                  <strong>enVision Server Primary User: </strong>{params.row.enVisionServerPrimaryUser}
                  <br />
                </>
              }
              {params.row.enVisionServerPrimaryUserSecret &&
                <>
                  <strong>enVision Server Primary User Secret: </strong>{hideSecret(params.row.enVisionServerPrimaryUserSecret)}
                </>
              }
            </div>
          </>
        );
      }
    },
    {
      field: "workflowTypes",
      headerName: "Workflow Types",
      minWidth: 200,
      hide: true,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && Object.keys(params.value).map((workflowType) => (
              <><strong>{workflowType}</strong>:&nbsp;{params.value[workflowType]}<br /></>
            ))}
          </div>
        );
      },
    },
    {
      field: "workflowFeatures",
      headerName: "Workflow Features",
      minWidth: 200,
      hide: true,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && Object.keys(params.value).map((workflowType) => (
              <><strong><u>{workflowType}</u></strong>:<br />
                {Object.keys(params.value[workflowType]).map((feature) => (
                  <>&nbsp;&nbsp;{feature}:{params.value[workflowType][feature].toString()}<br /></>
                )
                )
                }
                <br />
              </>
            ))}
          </div>
        );
      },
    },
    {
      field: "exceptionflowTypes",
      headerName: "Exception Flow Types",
      minWidth: 200,
      hide: true,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && Object.keys(params.value).map((exceptionFlowType) => (
              <><strong>{exceptionFlowType}</strong>:&nbsp;{params.value[exceptionFlowType]}<br /></>
            ))}
          </div>
        );
      },
    },
    {
      field: "cspUpdateUris",
      headerName: "CSP Update URIs",
      minWidth: 200,
      hide: true,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
            {params.value && Object.keys(params.value).map((workflowType) => (
              <><strong>{workflowType}</strong>:&nbsp;{params.value[workflowType]}<br /></>
            ))}
          </div>
        );
      },
    }
  ];

  const viewEditData = useCallback((rowData) => () => {
    // console.log("view/edit icon clicked", rowData);
    let isEnvision = rowData.hasOwnProperty('enVisionCompanyCreated') && rowData['enVisionCompanyCreated'];
    //console.log(isEnvision);
    // remove the id from table data as table data only not part of json stored
    const {
      id,
      ...JsonData
    } = rowData;

    setOriginalClientSecret(JsonData.enVisionServerUserSecret);
    setOriginalCspTenantSecret(JsonData.cspTenantSecret);
    setOriginalEnVisionServerPrimaryUserSecret(JsonData.enVisionServerPrimaryUserSecret);

    let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

    // transform workflow features object format to string format for edit dialog
    transformWorkflowFeaturesToStringFormat(formattedData);

    transformCspToMDMToStringFormat(formattedData);

    // transform sizeLimits object format to string format for edit dialog
    transformSizeLimitsToStringFormat(formattedData);

    formattedData.enVisionServerUserSecret = hideSecret(formattedData.enVisionServerUserSecret);
    formattedData.cspTenantSecret = hideSecret(formattedData.cspTenantSecret);
    formattedData.enVisionServerPrimaryUserSecret = hideSecret(formattedData.enVisionServerPrimaryUserSecret);

    setRowJsonData(formattedData);
    setMode('edit');
    setReadOnly(false);
    setOpen(true);
  }, []);

  const reindexCompanyData = useCallback((rowData) => () => {

    let companyId = rowData.companyId;
    let companyName = rowData.name;

    let title = "Reindex Company?";
    let msg = `The CSP documents for the company '${companyName}' will be re-indexed. Are you sure?`;

    let confirmProps = {
      title,
      msg,
      confirmCallback: () => reIndexCompany(companyId)
    };

    setConfirmProps(confirmProps);

    setConfirmOpen(true);
  }, []);

  const setEnVisionCompany = useCallback((rowData) => () => {
    setAction('view');
    getEnVisionCompany(rowData);
  }, []);

  const editEnVisionCompany = useCallback((rowData) => () => {
    setAction('edit');
    getEnVisionCompany(rowData);
  }, []);

  const createEnVisionCompany = useCallback((rowData) => () => {
    setAction('create');
    setShowDialog(true);
    setEnVisionData(rowData);
  }, []);


  const reIndexCompany = (companyId) => {

    setIsReindexing(true);

    setOpenInfoDialog(true);

    // POST https://cdvdata-d1-c1.dit01-insight-csp.com/monitor/api/companies/207931/cspReindex
    let reindexUrl = `/api/companies/${companyId}/cspReindex`;

    axios({
      method: "post", url: reindexUrl,
      headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
    })
      .then(response => {
        setIsReindexing(false);

      }).catch(error => {
        console.log('error in reindex company api call:', error);

        setIsReindexing(false);

        let message = `Failed to reindex company [${companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;


        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });
      });
  };



  const viewRowData = (param, event) => {
    // remove the id from table data as table data only not part of json stored
    const {
      id,
      ...JsonData
    } = param.row;

    setOriginalClientSecret(JsonData.enVisionServerUserSecret);
    setOriginalCspTenantSecret(JsonData.cspTenantSecret);
    setOriginalEnVisionServerPrimaryUserSecret(JsonData.enVisionServerPrimaryUserSecret);

    let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

    // transform workflow features to string object for view dialog
    transformWorkflowFeaturesToStringFormat(formattedData);

    transformCspToMDMToStringFormat(formattedData);

    // transform sizeLimits object format to string format for view dialog
    transformSizeLimitsToStringFormat(formattedData);

    formattedData.enVisionServerUserSecret = hideSecret(formattedData.enVisionServerUserSecret);
    formattedData.cspTenantSecret = hideSecret(formattedData.cspTenantSecret);
    formattedData.enVisionServerPrimaryUserSecret = hideSecret(formattedData.enVisionServerPrimaryUserSecret);

    setRowJsonData(formattedData);
    setMode('view');
    setReadOnly(true);
    setOpen(true);
  };


  const fetchData = async (apiURL2, qparams) => {
    setIsloading(true);
    await fetchAPIData(apiURL2, qparams)
      .then((data) => {
        setApiData(data);
        setCompany(data);
        // clear the reload false now that data is loaded
        setReload(false);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);

        let message = `Failed to load company data \n\n ${err.response.statusText} : ${err.response.data.message}`;
        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });

        setReload(false);
        setIsloading(false);
      });

  }

  /*
   * Convert workflow features string format to object format
   */
  const transformWorkflowFeaturesToObject = (data) => {
    // check if data exists
    if (data) {
      let workflowFeatures = data;

      for (let key in workflowFeatures) {

        if (typeof workflowFeatures[key] === 'string') {
          let featureObj = {};
          let values = workflowFeatures[key].split(',');

          if (values) {
            values.forEach((item) => {
              let dataValues = item.split('=');

              let featureName = dataValues[0].trim();
              let featureValue = dataValues[1].trim();
              featureObj[featureName] = featureValue;
            });

            workflowFeatures[key] = featureObj;
          }
        }
      }
    }
  };

  /*
  * Convert CSP to MDM document types string format to object format
  */
  const transformCspToMDMTypesToObject = (data) => {
    // check if data exists
    if (data.cspToMDMDocumentTypes) {
      let cspToMDMTypes = data.cspToMDMDocumentTypes;
      let cspToMDMTypesObj = {};

      let values = cspToMDMTypes.split(',');

      if (values) {
        values.forEach((item) => {
          let dataValues = item.split('=');

          let cspDocType = dataValues[0].trim();
          let MDMDocType = dataValues[1].trim();
          cspToMDMTypesObj[cspDocType] = MDMDocType;
        });
      }

      data.cspToMDMDocumentTypes = cspToMDMTypesObj;
    }
  };

  /*
  * Convert sizeLimits string format to object format
  */
  const transformSizeLimitsToObject = (data) => {
    // check if data exists
    if (data.sizeLimits !== '') {
      let sizeLimits = data.sizeLimits;
      let sizeLimitsObj = {};

      let values = sizeLimits.split(',');

      if (values) {
        values.forEach((item) => {
          let dataValues = item.split('=');

          let fileType = dataValues[0].trim();
          let fileSizeLimit = dataValues[1].trim();
          sizeLimitsObj[fileType] = parseInt(fileSizeLimit);  // convert to Integer
        });
      }

      data.sizeLimits = sizeLimitsObj;
    } else {
      // empty string - send empty object
      data.sizeLimits = {};
    }
  };

  const handleJsonChange = (formData) => {
    // console.log("Dialog JSON has changed", formData);

    setRowJsonData(formData);
  };

  const handleFormChange = (data) => {
    // console.log("called handleFormChange", data);

    setRowJsonData(data.formData);
  };

  const validateSchema = (companySchema, data) => {
    // console.log('got json schema', companySchema);
    const validate = ajv.compile(companySchema);
    const valid = validate(data);
    if (!valid) {
      console.log(validate.errors);
      return false;
    }
    return true;
  }

  const saveCompanyData = (formData) => {
    // console.log('current mode:', mode);
    // console.log('called save company:', formData);

    // react json form generates an empty object when nothing set.
    // This is causing issues in backend API when fields are validated for blank (especially eventTopics)
    let cleanedObj = cleanObject(formData);

    if (mode === 'edit') {
      if (validateSchema(companySchemaUpdateRequired, cleanedObj)) {
        if (validateSchema(companySchemaUpdateOptional, cleanedObj)) {
          // console.log('update company schema validated successfully..');
          updateCompany(cleanedObj);
        }
        else {
          console.log('update schema validation failed for optional params..');
          let message = `Update company schema validation failed for optional parameters`;

          setNotify({
            isOpen: true,
            alertTitle: 'Schema Validation Failure',
            message: message,
            severity: 'error'
          });
        }
      } else {
        console.log('update schema validation failed..');
        let message = `Update company schema validation failed`;

        setNotify({
          isOpen: true,
          alertTitle: 'Schema Validation Failure',
          message: message,
          severity: 'error'
        });
      }
    }

    if (mode === 'create') {
      if (validateSchema(companySchemaRequired, cleanedObj)) {
        if (validateSchema(companySchemaOptional, cleanedObj)) {
          // console.log('create schema validated successfully..');
          createCompany(cleanedObj);
        }
        else {
          console.log('create schema validation failed for optional params..');
          let message = `Create company schema validation failed for optional parameters`;

          setNotify({
            isOpen: true,
            alertTitle: 'Schema Validation Failure',
            message: message,
            severity: 'error'
          });
        }
      }
      else {
        console.log('create schema validation failed..');
        let message = `Create company schema validation failed`;

        setNotify({
          isOpen: true,
          alertTitle: 'Schema Validation Failure',
          message: message,
          severity: 'error'
        });
      }
    }
  }

  const updateCompany = (data) => {
    try {
      // console.log('inside update company api..', data);

      // if solution has been cleared, then set solution value to null for payload
      if (data['solution'] === '') {
        data['solution'] = null;
      }

      // transform workflow features to object format for payload
      if (data.workflowFeatures) {
        transformWorkflowFeaturesToObject(data.workflowFeatures);
      }

      // transform CSP to MDM types to object format for payload
      if (data.cspToMDMDocumentTypes) {
        transformCspToMDMTypesToObject(data);
      }

      // transform sizeLimits to object format for payload
      if (data.sizeLimits) {
        transformSizeLimitsToObject(data);
      } else {
        // empty string - send empty object
        data.sizeLimits = {};
      }

      // password not changed so send original client secret
      if (data.enVisionServerUserSecret === HIDDEN_SECRET) {
        data.enVisionServerUserSecret = originalClientSecret;
      }

      // password not changed so send original client secret
      if (data.cspTenantSecret === HIDDEN_SECRET) {
        data.cspTenantSecret = originalCspTenantSecret;
      }

      // password not changed so send original EnVisionServerMasterUser secret
      if (data.enVisionServerPrimaryUserSecret === HIDDEN_SECRET) {
        data.enVisionServerPrimaryUserSecret = originalEnVisionServerPrimaryUserSecret;
      }

      axios({ method: "put", url: '/api/companies/' + data.companyId, data: data, headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() } })
        .then(response => {
          if (response.status === 200) {
            let message = `Company data updated successfully`;

            setNotify({
              isOpen: true,
              message: message,
              severity: 'info'
            });
            // console.log('got response from company update:', response);

            setReload(true);
            setOpen(false);
          }

        }).catch(error => {
          let message = `Company data update failed: ${error.response.data.message}`;

          setNotify({
            isOpen: true,
            alertTitle: 'Request failed',
            message: message,
            severity: 'error'
          });
          console.log('error in update company api call:', error.response.data.message);
        });
    }
    catch (e) {
      console.log(e);
      let message = `Company data update failed`;

      setNotify({
        isOpen: true,
        alertTitle: 'Request failed',
        message: message,
        severity: 'error'
      });
    }
  }

  const createCompany = (data) => {
    try {
      // console.log('inside company create api..', data);

      // if solution has been cleared, then set solution value to null for payload
      if (data['solution'] === '') {
        data['solution'] = null;
      }

      // transform workflow features to object format for payload
      if (data.workflowFeatures) {
        transformWorkflowFeaturesToObject(data.workflowFeatures);
      }

      // transform CSP to MDM types to object format for payload
      if (data.cspToMDMDocumentTypes) {
        transformCspToMDMTypesToObject(data);
      }

      // transform sizeLimits to object format for payload
      if (data.sizeLimits) {
        transformSizeLimitsToObject(data);
      } else {
        // empty string - send empty object
        data.sizeLimits = {};
      }

      axios({ method: "post", url: '/api/companies', data: data, headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() } })
        .then(response => {
          if (response.status === 200) {
            let message = `Company created successfully`;

            setNotify({
              isOpen: true,
              message: message,
              severity: 'info'
            });
            // console.log('got response from company update:', response);

            setReload(true);
            setOpen(false);
          }
        }).catch(error => {
          let message = `Company create failed: ${error.response.data.message}`;

          setNotify({
            isOpen: true,
            alertTitle: 'Request failed',
            message: message,
            severity: 'error'
          });
          console.log('error in update company api call:', error.response.data.message);
        });
    }
    catch (e) {
      console.log(e);
      let message = `Company create failed`;

      setNotify({
        isOpen: true,
        alertTitle: 'Request failed',
        message: message,
        severity: 'error'
      });
    }
  };

  const getSchema = (mode) => {
    if (mode === 'create') {
      return [companySchemaRequired, companySchemaOptional];
    } else if (mode === 'edit') {
      return [companySchemaUpdateRequired, companySchemaUpdateOptional];
    } else {
      // in view mode should be readonly so just choose update schema. 
      // may want to create a view schema
      return [companySchemaUpdateRequired, companySchemaUpdateOptional];
    }
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };


  const transformWorkflowFeaturesToStringFormat = (data) => {
    if (data) {
      if (data.workflowFeatures) {
        for (let key in data.workflowFeatures) {

          let formattedString = Object.entries(data.workflowFeatures[key]).map(([k, v]) => {
            return `${k}=${v}`;
          }).join(', ');

          data.workflowFeatures[key] = formattedString;
        }

      }
    }
  };

  const transformCspToMDMToStringFormat = (data) => {
    if (data) {
      if (data.cspToMDMDocumentTypes) {
        let formattedString = "";

        for (let key in data.cspToMDMDocumentTypes) {
          formattedString += `${key}=${data.cspToMDMDocumentTypes[key]}, `;
        }

        // remove trailing comma
        formattedString = formattedString.replace(/,\s*$/, "");

        data.cspToMDMDocumentTypes = formattedString;
      }
    }
  };

  const transformSizeLimitsToStringFormat = (data) => {
    if (data) {
      if (data.sizeLimits) {
        let formattedString = "";

        for (let key in data.sizeLimits) {
          formattedString += `${key}=${data.sizeLimits[key]}, `;
        }

        // remove trailing comma
        formattedString = formattedString.replace(/,\s*$/, "");

        data.sizeLimits = formattedString;
      }
    }
  };

  const getEnVisionCompany = (data) => {
    setReadOnly(true);
    const url = `/api/companies/${data?.companyId}/evCompany`;
    axios({
      method: "get",
      url: url,
      headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
    }).then((data) => {
      //console.log(data);
      setEnVisionData(data.data);
      setShowDialog(true);
    }).catch((error) => {
      console.log('error in get enVision company data api call:', error);

      let message = `Failed to get enVision data [${data.companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

      setNotify({
        isOpen: true,
        alertTitle: 'Get enVision request failed',
        message: message,
        severity: 'error'
      });
    })
  }
  //----
  return (
    <>

      <AlertSnackbar
        notify={notify}
        setNotify={setNotify} />

      <div id="headerContainer" className="headerContainer">
        <div id="companyHeader" className="companyHeaderContainer">
          <div id="content-left" className="content-left">
            <div id="companyPageTitle" className="companyPageTitle">Companies</div>
            <PermissionsCheck
              RenderError={() => <></>}
              scopes={companyManage}>
              <div id="subhead" className="subhead">
                <Button variant="text" endIcon={<AddBoxIcon color="primary" />} className="subheadText" onClick={handleClickOpen}>Create Company</Button>
              </div>
            </PermissionsCheck>


          </div>
        </div>
      </div>


      <div id="filterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
        <Filter permission={companyPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL='/api/companies?' fetchData={fetchData} useCompanyId={false} totalLabel={totalLabel} reload={reload} tabName={'companiesTab'} />
      </div>


      <Divider />

      <div id="companyTableContainer" className={toggleColumnPinning()}>
        <div>
          <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
        </div>
      </div>


      <ActionDialog
        open={open}
        mode={mode}
        onClose={handleClose}
        onSave={() => handleSave(formId, rowJsonData, saveCompanyData)}
        title="Company Information"
        propertiesTabContent={
          <div>
            <Typography style={{ fontWeight: 'bold' }}>Required Fields</Typography>
            <CompanyDialog formId={formId} companySchema={getSchema(mode)[0]} uiSchema={uiSchema}
              saveCompanyData={saveCompanyData} formData={rowJsonData}
              handleFormChange={handleFormChange} readOnly={readOnly} />
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography style={{ fontWeight: 'bold' }}>Optional Fields</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <CompanyDialog formId={formId} companySchema={getSchema(mode)[1]} uiSchema={uiSchema}
                    saveCompanyData={saveCompanyData} formData={rowJsonData}
                    handleFormChange={handleFormChange} readOnly={readOnly} />
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        }
        jsonDataName="companies"
        JSONTabContent={rowJsonData}
        handleJsonChange={handleJsonChange}
      />


      <InfoDialog
        open={openInfoDialog}
        onClose={handleInfoDialogClose}
        title={reindexDialogTitle}
        content={reindexTextContent}
      />

      <CompanyEnvisionDialog
        open={showDialog}
        onClose={handleDialogClose}
        handleClose={handleDialogClose}
        action={action}
        data={data}
        setReload={setReload}
      />

      <ConfirmDialog
        title={confirmProps.title}
        open={confirmOpen}
        onClose={handleConfirmClose}
        setOpen={setConfirmOpen}
        cancelButtonText={confirmProps.cancelButtonText}
        confirmButtonText={confirmProps.confirmButtonText}
        onConfirm={confirmProps.confirmCallback}
      >
        {confirmProps.msg}
      </ConfirmDialog>

    </>
  );

}

export default Companies;